import { render, staticRenderFns } from "./myExam.vue?vue&type=template&id=fa32a6c6&scoped=true&"
import script from "./myExam.vue?vue&type=script&lang=js&"
export * from "./myExam.vue?vue&type=script&lang=js&"
import style0 from "./myExam.vue?vue&type=style&index=0&id=fa32a6c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa32a6c6",
  null
  
)

export default component.exports